<template>
    <div>
        <el-form ref="form" :inline="true" :model="searcheModel">
            <el-form-item label="录单时间">
                <el-date-picker
                    size="small"
                    v-model="searcheModel.order_created_at"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="所属部门">
                <UserCascader
                    v-model="searcheModel.branch_id"
                    ref="branch"
                    :isBusiness="true"
                    @change="changeBranch"
                ></UserCascader>
            </el-form-item>
            <el-form-item label="业务员">
                <OrderUserSelect ref="user" :uid="searcheModel.user_id" @change="CorpHandleChange" clearable></OrderUserSelect>
            </el-form-item>
            <el-form-item label="订单类型">
                <el-select size="small" v-model="searcheModel.order_type" placeholder="请选择">
                    <!-- <el-option label="试用" value="1"></el-option> -->
                    <el-option label="正式(新单)" value="2"></el-option>
                    <el-option label="正式(续单)" value="3"></el-option>
                    <el-option label="正式" value="4"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="财务审核">
                <el-select size="small" v-model="searcheModel.finance_audit" placeholder="请选择">
                    <el-option label="不限" value=""></el-option>
                    <el-option label="通过" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="屏蔽排课升级单">
                <el-select size="small" v-model="searcheModel.not_have_amount" placeholder="请选择">
                    <el-option label="不限" value=""></el-option>
                    <el-option label="是" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="成交来源">
                <el-select size="small" v-model="searcheModel.source" placeholder="请选择">
                    <el-option label="不限" value=""></el-option>
                    <el-option label="无" value="0"></el-option>
                    <el-option label="线索转化" value="1"></el-option>
                    <el-option label="业务员自拓" value="2"></el-option>
                    <el-option label="客户转介绍" value="3"></el-option>
                    <el-option label="学海行舟公益行" value="4"></el-option>
                    <el-option label="国培教育" value="5"></el-option>
                    <el-option label="400官网高价值线索" value="7"></el-option>
                    <el-option label="运营孵化高价值线索" value="8"></el-option>
                    <el-option label="龙岗区教育局" value="9"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="产品类型">
                <Product ref="product" :product_id="searcheModel.product_id"
                @change="productChange"></Product>
            </el-form-item>
            <el-form-item label="开通版本" v-if="searcheModel.product_id > 0">
                <el-select size="small" v-model="searcheModel.product_type" placeholder="请选择">
                    <el-option label="不限" value=""></el-option>
                    <el-option label="标准版" value="1"></el-option>
                    <el-option label="额度版" value="2"></el-option>
                </el-select>
            </el-form-item>
            <DistrictLinkage ref="DistrictLinkage" :provinceId="searcheModel.province_id" :cityId="searcheModel.city_id" :districtId="searcheModel.district_id" @change="handleChange"></DistrictLinkage>
            <el-form-item>
                <el-button type="primary" size="small" @click="submitSearch" :loading="loading">搜索</el-button>
                <el-button @click="resetForm()" size="small" :loading="loading">重置</el-button>
            </el-form-item>
        </el-form>
        <el-tabs type="card" v-model="searcheModel.count_type" @tab-click="listTypeClick">
            <el-tab-pane label="按部门" name="1"></el-tab-pane>
            <el-tab-pane label="按成员" name="2"></el-tab-pane>
        </el-tabs>
        <el-collapse v-model="collapses" @change="collapseHandleChange">
            <el-collapse-item :name="1">
                <template slot="title">
                    订单业绩分析
                    <ExportFile 
                    url="/api/export/order-finish" 
                    :params="searcheModel" 
                    filename="订单业绩分析" 
                    buttonName="导出Excel"
                    @click.native.stop>
                    </ExportFile>
                </template>
                
                <el-table
                    v-loading="loading" 
                    :data="list" 
                    border 
                    row-key="id" 
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    max-height="500"
                    :header-cell-style="{background: '#f3faff'}"
                    show-summary
                    :summary-method="getSummariesFinish" 
                >
                    <template v-if="searcheModel.count_type == 1">
                    <el-table-column prop="name" label="部门" width="200"></el-table-column>
                    <el-table-column prop="leader_name" label="部门负责人"></el-table-column>
                    </template>
                    <template v-else>
                        <el-table-column prop="name" label="业务员"></el-table-column>
                        <el-table-column prop="branch_name" label="所属部门"></el-table-column>
                    </template>
                    <!-- <el-table-column prop="user_name" label="业务员"></el-table-column>
                    <el-table-column prop="branch_name" label="所属部门"></el-table-column> -->
                    <el-table-column prop="this_total_amount" sortable label="销售额"></el-table-column>
                    <el-table-column prop="order_num" sortable label="订单数"></el-table-column>
                    <el-table-column prop="last_order_num" sortable label="订单同比"></el-table-column>
                    <el-table-column prop="order_num_ratio" sortable label="订单年增长">
                    <template slot-scope="scope">
                        {{scope.row.order_num_ratio + '%'}}
                    </template>
                    </el-table-column>
                    <el-table-column prop="this_pfm_amount" sortable label="新增业绩"></el-table-column>
                    <el-table-column prop="last_pfm_amount" sortable label="新增业绩同比"></el-table-column>
                    <el-table-column prop="pfm_amount_ratio" sortable label="新增业绩年增长">
                    <template slot-scope="scope">
                        {{scope.row.pfm_amount_ratio + '%'}}
                    </template>
                    </el-table-column>
                    <el-table-column prop="this_renew_amount" sortable label="续费业绩"></el-table-column>
                    <el-table-column prop="last_renew_amount" sortable label="续费业绩同比"></el-table-column>
                    <el-table-column prop="renew_amount_ratio" sortable label="续费业绩年增长">
                    <template slot-scope="scope">
                        {{scope.row.renew_amount_ratio + '%'}}
                    </template>
                    </el-table-column>
                    <el-table-column prop="this_actual_amount" sortable label="实际回款金额"></el-table-column>
                    <el-table-column prop="this_finish_amount" sortable label="续费完成金额"></el-table-column>
                </el-table>
            </el-collapse-item>
            <el-collapse-item :name="2">
                <template slot="title">
                    订单成交来源分析
                    <ExportFile 
                    url="/api/export/order-source" 
                    :params="searcheModel" 
                    filename="订单成交来源分析" 
                    buttonName="导出Excel"
                    @click.native.stop>
                    </ExportFile>
                </template>
                <el-table
                    v-loading="source_loading" 
                    :data="source_list" 
                    border 
                    row-key="id" 
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    max-height="500"
                    :header-cell-style="{background: '#f3faff'}"
                    show-summary
                    :summary-method="getSummariesSource" 
                >
                    <template v-if="searcheModel.count_type == 1">
                        <el-table-column prop="name" label="部门" width="200"></el-table-column>
                        <el-table-column prop="leader_name" label="部门负责人"></el-table-column>
                    </template>
                    <template v-else>
                        <el-table-column prop="name" label="业务员"></el-table-column>
                        <el-table-column prop="branch_name" label="所属部门"></el-table-column>
                    </template>
                    <el-table-column prop="order_num" label="订单数"></el-table-column>
                    <el-table-column prop="clue_num" label="线索转化"></el-table-column>
                    <el-table-column prop="clue_ratio" label="占比">
                        <template slot-scope="scope">
                            {{scope.row.clue_ratio > 0 ? scope.row.clue_ratio + '%' : ''}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="expand_num" label="业务员自拓"></el-table-column>
                    <el-table-column prop="expand_ratio" label="占比">
                        <template slot-scope="scope">
                            {{scope.row.expand_ratio > 0 ? scope.row.expand_ratio + '%' : ''}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="introduct_num" label="客户转介绍"></el-table-column>
                    <el-table-column prop="introduct_ratio" label="占比">
                        <template slot-scope="scope">
                            {{scope.row.introduct_ratio > 0 ? scope.row.introduct_ratio + '%' : ''}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="gongyi_num" label="学海行舟公益行"></el-table-column>
                    <el-table-column prop="gongyi_ratio" label="占比">
                        <template slot-scope="scope">
                            {{scope.row.gongyi_ratio > 0 ? scope.row.gongyi_ratio + '%' : ''}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="guopei_num" label="国培教育"></el-table-column>
                    <el-table-column prop="guopei_ratio" label="占比">
                        <template slot-scope="scope">
                            {{scope.row.guopei_ratio > 0 ? scope.row.guopei_ratio + '%' : ''}}
                        </template>
                    </el-table-column>
                </el-table>
            </el-collapse-item>
            <el-collapse-item :name="3">
                <template slot="title">
                    业务员成交产品分布
                    <ExportFile 
                    url="/api/export/user-order-product" 
                    :params="searcheModel" 
                    filename="业务员成交产品分布" 
                    buttonName="导出Excel"
                    @click.native.stop>
                    </ExportFile>
                </template>
                <el-table
                    v-loading="user_product_loading" 
                    :data="user_product_list"
                    border
                    row-key="id" 
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    max-height="500"
                    show-summary>
                    <template v-if="searcheModel.count_type == 1">
                        <el-table-column prop="name" label="部门" width="200"></el-table-column>
                        <el-table-column prop="leader_name" label="部门负责人"></el-table-column>
                    </template>
                    <template v-else>
                        <el-table-column prop="name" label="业务员"></el-table-column>
                        <el-table-column prop="branch_name" label="所属部门"></el-table-column>
                    </template>
                    <el-table-column prop="product_id1" sortable label="二一组卷" width="130"></el-table-column>
                    <el-table-column prop="product_id2" sortable label="二一校网通" width="130"></el-table-column>
                    <el-table-column prop="product_id5" sortable label="校本资源库" width="130"></el-table-column>
                    <el-table-column prop="product_id6" sortable label="组卷合作机构" width="150"></el-table-column>
                    <el-table-column prop="product_id7" sortable label="在线备课" width="130"></el-table-column>
                    <el-table-column prop="product_id11" sortable label="数字化校园" width="130"></el-table-column>
                    <el-table-column prop="product_id14" sortable label="门户官网" width="130"></el-table-column>
                    <el-table-column prop="product_id97" sortable label="API" width="130"></el-table-column>
                    <el-table-column prop="product_id99" sortable label="广告或项目（资源）" width="150"></el-table-column>
                    <el-table-column prop="product_id103" sortable label="二一分班" width="130"></el-table-column>
                    <el-table-column prop="product_id105" sortable label="二一排课" width="130"></el-table-column>
                    <el-table-column prop="product_id106" sortable label="VR虚拟仿真实验" width="150"></el-table-column>
                    <el-table-column prop="product_id107" sortable label="项目（软件）" width="130"></el-table-column>
                    <el-table-column prop="product_id109" sortable label="排课软件服务" width="150"></el-table-column>
                    <el-table-column prop="product_id111" sortable label="二一学业评价" width="150"></el-table-column>
                    <el-table-column prop="product_id113" sortable label="二一作业" width="130"></el-table-column>
                    <el-table-column prop="product_id115" sortable label="智慧班牌" width="130"></el-table-column>
                    <el-table-column prop="product_id117" sortable label="新综合素质评价" width="150"></el-table-column>
                    <el-table-column prop="product_id119" sortable label="教学评价" width="130"></el-table-column>
                    <el-table-column prop="product_id120" sortable label="二一阅卷" width="130"></el-table-column>
                    <el-table-column prop="product_id121" sortable label="教师成长档案" width="150"></el-table-column>
                    <el-table-column prop="product_id123" sortable label="二一选课" width="130"></el-table-column>
                    <el-table-column prop="product_id125" sortable label="校本题库服务" width="150"></el-table-column>
                    <el-table-column prop="product_id127" sortable label="扫描仪" width="130"></el-table-column>
                    <el-table-column prop="product_id129" sortable label="条码机" width="130"></el-table-column>
                    <el-table-column prop="product_id131" sortable label="条码纸" width="130"></el-table-column>
                    <el-table-column prop="sum_amount" fixed="right" sortable label="合计" width="130"></el-table-column>
                </el-table>
            </el-collapse-item>
            <el-collapse-item :name="4">
                <template slot="title">
                    产品成交分布
                    <ExportFile 
                    url="/api/export/order-product" 
                    :params="searcheModel" 
                    filename="产品成交分布" 
                    buttonName="导出Excel"
                    @click.native.stop>
                    </ExportFile>
                </template>
                <el-table
                    v-loading="product_loading" 
                    :data="product_list"
                    border
                    row-key="id" 
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    max-height="500"
                    show-summary
                    :summary-method="getSummariesProduct"
                    >
                    <el-table-column prop="name" label="产品"></el-table-column>
                    <el-table-column prop="customer_num" label="成交客户数"></el-table-column>
                    <el-table-column prop="pfm_amount" label="新增业绩"></el-table-column>
                    <el-table-column prop="last_pfm_amount" label="新增业绩同比"></el-table-column>
                    <el-table-column prop="pfm_amount_ratio" label="新增业绩增长"></el-table-column>
                    <el-table-column prop="renew_amount" label="续费业绩"></el-table-column>
                    <el-table-column prop="last_renew_amount" label="续费业绩同比"></el-table-column>
                    <el-table-column prop="renew_amount_ratio" label="续费业绩增长"></el-table-column>
                    <el-table-column prop="sum_amount" sortable label="销售额"></el-table-column>
                    <el-table-column prop="year_num" sortable label="合作年限" width="130"></el-table-column>
                    <el-table-column prop="product_amount_ratio" sortable label="销售占比">
                        <template slot-scope="scope">
                        {{scope.row.product_amount_ratio + '%'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="last_sum_amount" sortable label="销售额同比">
                        <template slot-scope="scope">
                        {{scope.row.last_sum_amount}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="sum_amount_ratio" sortable label="销售额年增长">
                        <template slot-scope="scope">
                        {{scope.row.sum_amount_ratio + '%'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="order_num" sortable label="订单数"></el-table-column>
                    <el-table-column prop="last_order_num" sortable label="订单同比"></el-table-column>
                    <el-table-column prop="order_num_ratio" sortable label="订单年增长">
                        <template slot-scope="scope">
                        {{scope.row.order_num_ratio + '%'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="year_svg_price" sortable label="年均价"></el-table-column>
                    <el-table-column prop="last_year_svg_price" sortable label="年均价同比"></el-table-column>
                    <el-table-column prop="year_svg_price_ratio" sortable label="年均价增长">
                        <template slot-scope="scope">
                        {{scope.row.year_svg_price_ratio + '%'}}
                        </template>
                    </el-table-column>
                </el-table>
            </el-collapse-item>
            <el-collapse-item :name="5">
                <template slot="title">
                    成交地区分布
                    <ExportFile 
                    url="/api/export/order-area" 
                    :params="searcheModel" 
                    filename="成交地区分布" 
                    buttonName="导出Excel"
                    @click.native.stop>
                    </ExportFile>
                </template>
                <el-table
                    v-loading="area_loading" 
                    :data="area_list"
                    max-height="500"
                    row-key="id"
                    border
                    lazy
                    :load="loadArea"
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    show-summary
                    :summary-method="getSummariesArea">
                    <el-table-column prop="name" label="地区" width="180"></el-table-column>
                    <el-table-column prop="customer_num" label="客户总数" sortable></el-table-column>
                    <el-table-column prop="total_amount" label="销售额" sortable></el-table-column>
                    <el-table-column prop="year_num" label="合作年限"></el-table-column>
                    <el-table-column prop="total_pfm_amount" label="新增业绩" sortable></el-table-column>
                    <el-table-column prop="order_num" label="订单数"></el-table-column>
                    <el-table-column prop="year_svg_price" label="年均价" sortable></el-table-column>
                    <el-table-column prop="last_total_pfm_amount" label="新增业绩同比"></el-table-column>
                    <el-table-column prop="performance_ratio" label="新增业绩年增长">
                        <template slot-scope="scope">
                            {{ scope.row.performance_ratio }}%
                        </template>
                    </el-table-column>
                    <el-table-column prop="last_order_num" label="订单同比"></el-table-column>
                    <el-table-column prop="order_num_ratio" label="订单年增长">
                        <template slot-scope="scope">
                            {{ scope.row.order_num_ratio }}%
                        </template>
                    </el-table-column>
                    <el-table-column prop="last_year_svg_price" label="年均价同比"></el-table-column>
                    <el-table-column prop="year_svg_ratio" label="年均价增长">
                        <template slot-scope="scope">
                            {{ scope.row.year_svg_ratio }}%
                        </template>
                    </el-table-column>
                </el-table>
                
            </el-collapse-item>
        </el-collapse>
    </div>
</template>
<script>
import OrderCount from "~/services/OrderCount";
import UserCascader from "~/widgets/UserCascader.vue";
import OrderUserSelect from "~/widgets/OrderUserSelect.vue";
import Product from "~/widgets/Product.vue";
import DistrictLinkage from "~/widgets/DistrictLinkage.vue";
import ExportFile from "~/widgets/ExportFile.vue";
import Config from "~/config/params";
import TryConvOrderDialog from "~/views/count/dialog/TryConvOrderDialog.vue";
export default{
    name: 'conversion',
    
    components: {
        UserCascader,
        OrderUserSelect,
        Product,
        DistrictLinkage,
        ExportFile,
        Config,
        TryConvOrderDialog
    },

    data() {
        return {
            loading: false,
            list: [],

            source_loading: false,
            source_list: [],

            user_product_loading: false,
            user_product_list: [],

            product_loading: false,
            product_list: [],

            area_loading: false,
            area_list: [],

            searcheModel: {},
            collapses: [1, 2],
            collapse_length: 2,
        };
    },

    created(){
        this.resetForm();
    },
    
    methods: {

        //重置按钮
        resetForm() {
            this.searcheModel = {
                branch_id: "",
                user_id: "",
                order_created_at: Config.getDataTimes('to_day'),
                // year: new Date().getFullYear().toString(),
                product_id: '',
                product_type: '',
                order_type: '4',
                finance_audit: '1',
                source: '',
                province_id: 0,
                city_id: 0,
                district_id: 0,
                sort_name: '',
                sort_by: '',
                not_have_amount: '',
                count_type: '1',
            };
            if(this.$refs['branch']){
                this.$refs['branch'].reset();
            }
            if(this.$refs['user']){
                this.$refs['user'].reset();
            }
            if(this.$refs['product']){
                this.$refs['product'].reset();
            }
            this.list = [];
            this.submitSearch();
        },

        // 筛选查询
        submitSearch($data = null, collapse_name = null) {
            if($data && typeof $data.order !== undefined){
                this.searcheModel.sort_name = $data['prop'];
                this.searcheModel.sort_by = $data['order'];
            }
            let params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            if (!collapse_name && this.collapses.includes(1) || collapse_name == 1){
                this.getList(params);
            }
            if (!collapse_name && this.collapses.includes(2) || collapse_name == 2){
                this.getSourceList(params);
            }
            if (!collapse_name && this.collapses.includes(3) || collapse_name == 3){
                this.getUserProductList(params);
            }
            if (!collapse_name && this.collapses.includes(4) || collapse_name == 4){
                this.getProductList(params);
            }
            if (!collapse_name && this.collapses.includes(5) || collapse_name == 5){
                this.getAreaList(params);
            }
        },

        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            this.list = [];
            OrderCount.getPayOrderCount(params, 'order-finish')
            .then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                this.loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        //来源情况列表
        getSourceList(params) {
            // loading 动画
            this.source_loading = true;
            this.source_list = [];
            OrderCount.getPayOrderCount(params, 'order-source')
            .then((res) => {
                if (res.code == 0) {
                    this.source_list = res.data;
                }
                this.source_loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.source_loading = false;
            });
        },

        //业务员产品
        getUserProductList(params) {
            // loading 动画
            this.user_product_loading = true;
            this.user_product_list = [];
            OrderCount.getPayOrderCount(params, 'user-order-product')
            .then((res) => {
                if (res.code == 0) {
                    this.user_product_list = res.data;
                }
                this.user_product_loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.user_product_loading = false;
            });
        },

        //产品列表
        getProductList(params) {
            // loading 动画
            this.product_loading = true;
            this.product_list = [];
            OrderCount.getPayOrderCount(params, 'order-product')
            .then((res) => {
                if (res.code == 0) {
                    this.product_list = res.data;
                }
                this.product_loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.product_loading = false;
            });
        },

        //地区情况列表
        getAreaList(params) {
            // loading 动画
            this.area_loading = true;
            this.area_list = [];
            OrderCount.getPayOrderCount(params, 'order-area')
            .then((res) => {
                if (res.code == 0) {
                    this.area_list = res.data;
                }
                this.area_loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.area_loading = false;
            });
        },
        
        loadArea(tree, treeNode, resolve){
            // console.log(tree, treeNode, resolve);
            let params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            if(tree.level == 1){
                params.province_id = tree.province_id;
            }else if(tree.level == 2){
                params.city_id = tree.city_id;
            }
            OrderCount.getPayOrderCount(params, 'order-area')
            .then((res) => {
                if (res.code == 0) {
                    resolve(res.data)
                }
            })
            .catch((err) => {
                console.error(err);
            });
        },

        //切换部门子组件
        changeBranch(value) {
            if (value.length > 0) {
                // 取得最后一级部门作为所属部门
                this.searcheModel.branch_id = value[value.length - 1];
            } else {
                this.searcheModel.branch_id = "";
            }
        },

        CorpHandleChange($event){
            this.searcheModel.user_id = $event.id;
        },

        productChange(value) {
            this.searcheModel.product_id = value;
            if(this.searcheModel.product_id <= 0){
                this.searcheModel.product_type = ''
            }
        },

        //地区联动 Cascader 级联选择器,切换事件,表单model赋值
        handleChange(value) {
            this.searcheModel.province_id = parseInt(value[0]);
            this.searcheModel.city_id = parseInt(value[1]);
            this.searcheModel.district_id = parseInt(value[2]);
        },

        collapseHandleChange(val) {
            if(val && val.length > this.collapse_length){
                const clicked_name = val[val.length - 1];
                this.submitSearch(null, clicked_name);
            }
            this.collapse_length = val.length;
        },

        listTypeClick(){
            this.submitSearch();
        },

        getSummariesFinish(param) {
            // columns 是所有列的一个数组
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                // column 是每一列，index 表示列的索引，第一列的时候不计算合计，显示自定义的文字内容
                if (index === 0) {
                sums.push('共' + this.list.length + '条');
                return;
                }else if(index === 1){
                sums.push('合计：');
                return;
                }
                //下面这一坨代码就是把每一列中的所有单元格中的值转化成Number型，
                //然后对转化后的结果进行判断，如果是number型，则进行累加，
                //如果NaN型，说明单元格里是一些无法转化成number型的值，则返回自定义的内容
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                sums[index] = Math.round(values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!isNaN(value)) {
                    return prev + curr;
                    } else {
                    return prev;
                    }
                }, 0) * 100) / 100;
                } else {
                sums.push(0);
                }
            });
            sums[5] = (sums[4] > 0 ? Math.round((sums[3] - sums[4]) / sums[4] * 10000) / 100 : 0) + '%';
            sums[8] = (sums[7] > 0 ? Math.round((sums[6] - sums[7]) / sums[7] * 10000) / 100 : 0) + '%';
            sums[11] = (sums[10] > 0 ? Math.round((sums[9] - sums[10]) / sums[10] * 10000) / 100 : 0) + '%';
            return sums;
        },

        getSummariesSource(param) {
            // columns 是所有列的一个数组
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                // column 是每一列，index 表示列的索引，第一列的时候不计算合计，显示自定义的文字内容
                if (index === 0) {
                sums.push('合计：');
                return;
                }else if(index < 2){
                return;
                }
                //下面这一坨代码就是把每一列中的所有单元格中的值转化成Number型，
                //然后对转化后的结果进行判断，如果是number型，则进行累加，
                //如果NaN型，说明单元格里是一些无法转化成number型的值，则返回自定义的内容
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                sums[index] = Math.round(values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!isNaN(value)) {
                    return prev + curr;
                    } else {
                    return prev;
                    }
                }, 0) * 100) / 100;
                } else {
                sums.push(0);
                }
            });
            sums[4] = (sums[2] > 0 ? Math.round(sums[3] / sums[2]* 10000) / 100 : 0) + '%';
            sums[6] = (sums[2] > 0 ? Math.round(sums[5] / sums[2] * 10000) / 100 : 0) + '%';
            sums[8] = (sums[2] > 0 ? Math.round(sums[7] / sums[2] * 10000) / 100 : 0) + '%';
            return sums;
        },

        getSummariesProduct(param) {
            // columns 是所有列的一个数组
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                // column 是每一列，index 表示列的索引，第一列的时候不计算合计，显示自定义的文字内容
                if (index === 0) {
                sums.push('共' + this.product_list.length + '条');
                return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                sums[index] = Math.round(values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!isNaN(value)) {
                    return prev + curr;
                    } else {
                    return prev;
                    }
                }, 0) * 100) / 100;
                } else {
                sums.push(0);
                }
            });
            sums[10] = '--';
            sums[12] = (sums[11] > 0 ? Math.round((sums[8] - sums[11]) / sums[11] * 10000) / 100 : 0) + '%';
            sums[15] = (sums[12] > 0 ? Math.round((sums[13] - sums[14]) / sums[14] * 10000) / 100 : 0) + '%';
            sums[18] = (sums[17] > 0 ? Math.round((sums[16] - sums[17]) / sums[17] * 10000) / 100 : 0) + '%';
            return sums;
        },
        getSummariesArea(param) {
            // columns 是所有列的一个数组
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                // column 是每一列，index 表示列的索引，第一列的时候不计算合计，显示自定义的文字内容
                if (index === 0) {
                sums.push('共' + this.area_list.length + '条');
                return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                sums[index] = Math.round(values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!isNaN(value)) {
                    return prev + curr;
                    } else {
                    return prev;
                    }
                }, 0) * 100) / 100;
                } else {
                sums.push(0);
                }
            });
            sums[8] = (sums[7] > 0 ? Math.round((sums[4] - sums[7]) / sums[7] * 10000) / 100 : 0) + '%';
            sums[10] = (sums[9] > 0 ? Math.round((sums[5] - sums[9]) / sums[9] * 10000) / 100 : 0) + '%';
            sums[12] = (sums[11] > 0 ? Math.round((sums[6] - sums[11]) / sums[11] * 10000) / 100 : 0) + '%';
            // console.log(sums, data, columns);
            return sums;
        },
    }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/count/payorder/finish.vue